import { C2PType } from '../types';
import { NOT_SURE } from './form';

export function toForm(
  { person: { vtr_id = "", is_email_verified = false}, relation: { company_vtr_id = "",source_links="", designation = "",description="", currently_working = "", person_company_relation_id = "", markets_responsible = ""} }: C2PType
) {
  return {
    person_vtr_id: vtr_id,
    company_vtr_id,
    designation,
    description,
    currently_working: currently_working === "" ? NOT_SURE : currently_working,
    person_company_relation_id,
    is_email_verified,
    source_links,
    markets_responsible: markets_responsible ?? '',
  }
}